export function matchPhones(query: string, phone: string) {
  const cleaned = query.replaceAll('+', '')

  return phone.includes(cleaned)
}

export function matchEmails(query: string, email: string) {
  return email.includes(query)
}
